module.exports = __webpack_public_path__ + "static/media/JF Horizontal Color.9eb4a247.png";